import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "nav" }, [
  /*#__PURE__*/_createElementVNode("span", null, "记录APP列表")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_el_table, {
      data: _ctx.list,
      style: {"width":"100%","min-height":"500px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "deviceId",
          label: "设备id",
          width: "380"
        }),
        _createVNode(_component_el_table_column, {
          prop: "user.phone",
          label: "用户手机号",
          width: "240"
        }),
        _createVNode(_component_el_table_column, {
          label: "日志数",
          width: "240"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              type: "text",
              size: "small",
              onClick: _withModifiers(($event: any) => (_ctx.onViewLogList(scope.row.deviceId)), ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.logCount), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.log?"记录中":"未记录") + "     ", 1),
            _createVNode(_component_el_button, {
              type: "text",
              size: "small",
              onClick: _withModifiers(($event: any) => (_ctx.onToggleLogStatus(scope.row)), ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.log?"关闭":"开启"), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "最后操作时间" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(new Date(scope.row.lastLogTime).toLocaleString("zh-CN", { hour12: false })), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      layout: "prev, pager, next",
      "current-page": _ctx.pagination.page,
      "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination.page) = $event)),
      "page-count": _ctx.pagination.pageCount
    }, null, 8, ["current-page", "page-count"])
  ]))
}